import { render, staticRenderFns } from "./HorizontalBarsChart.vue?vue&type=template&id=465efa53&scoped=true&"
import script from "./HorizontalBarsChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarsChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarsChart.vue?vue&type=style&index=0&id=465efa53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465efa53",
  null
  
)

export default component.exports
import {QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinnerTail})
